import React from "react";
import img1 from "../assets/one.jpg";
import img2 from "../assets/two.jpg";
import img3 from "../assets/three.png";
import img4 from "../assets/four.jpg.avif";

const ProjectsSection = () => {
  return (
    <>
      <style>{`
        .projects-section {
          background: #DCF6C6;
          padding: 100px 20px;
          position: relative;
        }

        .projects-container {
          max-width: 1100px;
          margin: auto;
          text-align: center;
        }

        /* ✅ FIXED HEADING SIZE */
        .projects-container h2 {
          font-size: 36px;
          color: #0F3D2E;
          margin-bottom: 50px;
        }

        /* GRID */
        .projects-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 25px;
        }

        /* ✅ FIXED CARD SIZE */
        .project-card {
          position: relative;
          border-radius: 20px;
          overflow: hidden;
          height: 280px; /* reduced */
          cursor: pointer;
          transition: transform 0.4s ease;
        }

        .project-card img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s ease;
        }

        /* ✅ FIXED OVERLAY HEIGHT + CENTER ALIGN */
        .project-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 100%; /* FULL HEIGHT */

          display: flex;
          flex-direction: column;
          justify-content: flex-end; /* text stays bottom like design */
          align-items: flex-start;

          padding: 20px;
          color: white;

          background: linear-gradient(
            to top,
            rgba(15, 61, 46, 0.8),
            rgba(15, 61, 46, 0.3),
            rgba(15, 61, 46, 0.1)
          );

          transition: 0.4s ease;
        }

        .project-overlay h3 {
          font-size: 17px;
          margin-bottom: 5px;
          transform: translateY(10px);
          transition: 0.4s;
        }

        .project-overlay span {
          font-size: 13px;
          opacity: 0.9;
        }

        /* HOVER */
        .project-card:hover {
          transform: translateY(-6px);
        }

        .project-card:hover img {
          transform: scale(1.06);
        }

        .project-card:hover .project-overlay {
          background: linear-gradient(
            to top,
            rgba(15, 61, 46, 0.95),
            rgba(15, 61, 46, 0.5)
          );
        }

        .project-card:hover h3 {
          transform: translateY(0);
        }

        /* BUTTON */
        .projects-btn {
          margin-top: 50px;
          background: #7ED957;
          padding: 12px 26px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
          font-weight: 500;
          transition: 0.3s;
        }

        .projects-btn:hover {
          background: #D4AF37;
        }

        /* DECOR */
        .star {
          position: absolute;
          top: 40px;
          left: 60px;
          font-size: 80px;
          color: #7ED957;
          opacity: 0.4;
        }

        /* RESPONSIVE */
        @media (max-width: 900px) {
          .projects-grid {
            grid-template-columns: 1fr;
          }

          .projects-container h2 {
            font-size: 26px;
          }

          .project-card {
            height: 240px;
          }

          .star {
            display: none;
          }
        }
      `}</style>

      <section className="projects-section">
        <div className="star">*</div>

        <div className="projects-container">
          <h2>
            Real Client Solutions, Real Results,<br></br>
            Real Financial Growth
          </h2>

          <div className="projects-grid">

            <div className="project-card">
              <img src={img1} alt="" />
              <div className="project-overlay">
                <h3>Startup ITR & Compliance</h3>
                <span>2025</span>
              </div>
            </div>

            <div className="project-card">
              <img src={img2} alt="" />
              <div className="project-overlay">
                <h3>Small Business GST Filing</h3>
                <span>2025</span>
              </div>
            </div>

            <div className="project-card">
              <img src={img3} alt="" />
              <div className="project-overlay">
                <h3>Corporate Tax Planning</h3>
                <span>2025</span>
              </div>
            </div>

            <div className="project-card">
              <img src={img4} alt="" />
              <div className="project-overlay">
                <h3>Payroll & TDS Management</h3>
                <span>2025</span>
              </div>
            </div>

          </div>

        </div>
      </section>
    </>
  );
};

export default ProjectsSection;